import React from "react";
import { CachedAvatar } from "@/shared/components/ui/cached-avatar";

interface CurrentUserProfileProps {
  avatarUrl?: string;
  displayName: string;
  displayEmail: string;
}

export const CurrentUserProfile: React.FC<CurrentUserProfileProps> = ({
  avatarUrl,
  displayName,
  displayEmail,
}) => {
  return (
    <div className="flex items-center gap-3 p-3">
      <CachedAvatar
        src={avatarUrl}
        alt={displayName}
        size="lg"
        isSquircle={true}
      />
      <div className="flex-1 min-w-0">
        <p
          className="font-medium text-sm truncate"
          style={{ color: '#1e293b' }}
        >
          {displayName}
        </p>
        <p
          className="text-xs truncate opacity-75"
          style={{ color: '#1e293b' }}
        >
          {displayEmail}
        </p>
      </div>
    </div>
  );
};